<template>
  <div class="group-setup">
    <v-progress-linear
      indeterminate
      color="orange"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card class="pa-5">
      <v-card-title dark>
        <h3 class="ma-2">Extension of New Lions Club</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-form>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-text-field
              outlined
              dense
              v-model="form.name"
              label="Name of Club*"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-select
              v-model="form.club_type"
              :items="codes"
              :item-text="'name'"
              :item-value="'id'"
              label="Club Type"
              dense
              outlined
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <DatePicker
              :lable="'Date of Extended*'"
              v-model="form.date_extended"
              :setectVale="form.date_extended"
              @changeInput="form.date_extended = $event"
            ></DatePicker>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <AutocompleteSingleAvatar
              @changeData="changeChairman($event)"
              :storeLink="'member/getClubMembersBySearch'"
              :setectVale="form.chairman"
              :itemText="'name'"
              :label="'Select Chairman'"
            ></AutocompleteSingleAvatar>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-text-field
              outlined
              dense
              v-model="form.number_of_members"
              label="Number of members*"
              required
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <AutocompleteSingleAvatar
              @changeData="changeGuidingLion1($event)"
              :storeLink="'member/getClubMembersBySearch'"
              :setectVale="form.guiding_lion_1"
              :itemText="'name'"
              :label="'Guiding Lion 1'"
            ></AutocompleteSingleAvatar>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <AutocompleteSingleAvatar
              @changeData="changeGuidingLion2($event)"
              :storeLink="'member/getClubMembersBySearch'"
              :setectVale="form.guiding_lion_2"
              :itemText="'name'"
              :label="'Guiding Lion 2'"
            ></AutocompleteSingleAvatar>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-checkbox
              v-model="form.bonus_100pct_mjf"
              label="100% MJF Lions Club"
              dense
              outlined
              true-value="1"
              false-value="0"
            ></v-checkbox>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-checkbox
              v-model="form.bonus_100pct_maf"
              label="100% MAF Lions Club"
              dense
              outlined
              true-value="1"
              false-value="0"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-form>
      <v-divider></v-divider>
      <v-card-actions v-if="!cpRole">
        <v-row>
          <v-col cols="12" md="9" xs="6"></v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn
              large
              color="success"
              depressed
              :disabled="loading || !form.name"
              block
              @click="submit()"
              >Submit to Review</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import DatePicker from "@/components/shared/DatePicker";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import AutocompleteSingleAvatar from "@/components/shared/AutocompleteSingleAvatar";
import { ActivityService } from "../../../services/activity-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "groupSetUpFrom",

  components: { Alert, Snackbars, DatePicker, AutocompleteSingleAvatar },

  data: () => ({
    cpRole: false,
    loading: false,
    errors: null,
    snackbar: false,
    successMsg: "",
    projects: [],
    form: {
      name: "",
      number_of_members: "",
      club_type: "",
      date_extended: null,
      chairman: "",
      guiding_lion_1: "",
      guiding_lion_2: "",
      bonus_100pct_mjf: 0,
      bonus_100pct_maf: 0,
      month: "",
      key: "EXTENSION_NEW_LIONS_CLUB",
    },
    codes: [
      {
        id: "New Club",
        name: "New Club",
      },
      {
        id: "Branch Club",
        name: "Branch Club",
      },
      {
        id: "CUB Club",
        name: "CUB Club",
      },
    ],
  }),

  mounted() {},

  computed: {
    ...mapGetters({
      member: "profile",
    }),
  },

  methods: {
    submit() {
      this.errors = null;
      this.loading = true;
      this.snackbar = false;
      this.form.month = this.$route.params.month;
      ActivityService.submitActivity("extension-of-lion-club", this.form)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.$router.push("/activities/monthly");
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    changeChairman(value) {
      this.form.chairman = value;
    },

    changeGuidingLion1(value) {
      this.form.guiding_lion_1 = value;
    },

    changeGuidingLion2(value) {
      this.form.guiding_lion_2 = value;
    },

    onDismissed() {
      this.errors = null;
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.form.name = "";
    },
  },
};
</script>
